<script lang="ts">
    export let center: boolean = false;
    export let color: string = "var(--themeHeadingColor)";
    export let mb: string = "0.8em";
    export let style: string = "";
</script>

<h2
    class="subline"
    class:center
    style="--color: {color}; margin-bottom: {mb}; {style}"
>
    <slot />
</h2>

<style lang="scss">
    @import "./src/vars";

    .center {
        text-align: center;
    }
    h2 {
        color: var(--color);
        font-size: 2.3rem;
        font-weight: 600;
        margin-top: 0;
        line-height: 1.3em;
        @media (max-width: 800px) {
            font-size: 4vw;
        }
        @supports (font-size: clamp(1px, 1px, 1px)) {
            font-size: clamp(1.4rem, 4vw, 2.5rem);
        }
    }

    :global(body.light) {
        h1 + h2 {
            color: $gray !important;
        }
    }
</style>
